import AppError from '../components/AppError';
import NavigationNotification from '../components/NavigationNotification';
import Routes from '../routes';
import { AppContextProvider, AppContextProviderProps } from './Context';
import GlobalProviders from './GlobalProviders';
import useApp from './vm';

const AppContent = () => {
  useApp();

  return (
    <>
      <Routes />
      <AppError />
      <NavigationNotification />
    </>
  );
};

interface AppProps
  extends Pick<AppContextProviderProps, 'presentationId' | 'isNewPresentation' | 'activeSlideId'> {}

const App = ({ presentationId, isNewPresentation, activeSlideId }: AppProps) => {
  return (
    <AppContextProvider
      presentationId={presentationId}
      isNewPresentation={isNewPresentation}
      activeSlideId={activeSlideId}
    >
      <GlobalProviders>
        <AppContent />
      </GlobalProviders>
    </AppContextProvider>
  );
};

export default App;
